import { MAIN_CATEGORY } from './main-category-field';

export const SUB_CATEGORY = 'category';

export function SUB_CATEGORY_FIELD(form, data: any) {
    return {
        id: SUB_CATEGORY,
        order: 1,
        elements: [
            {
                id: SUB_CATEGORY,
                type: 'select-2',
                name: SUB_CATEGORY,
                label: 'Sub category',
                space: 12,
                config: {
                    url: () => {
                        return data.url + '?parent=' + data.id;
                    },
                    relation: true,
                    searchKeyColumn: 'id',
                    searchQueryColumn: 'title',
                    searchDisplayColumn: 'title',
                    params: {
                        filter: 'id;code;title'
                    }
                },
                conditions: [{
                    element: MAIN_CATEGORY,
                    operator: '!=',
                    condition: null
                }],
                validation: {
                    // required: true,
                }
            }
        ]
    };
}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/observations/forms/sub-category-field.ts